import React from 'react';
import { Link } from 'react-router-dom';
// Constants
import {
  CompanyTagLine,
  CompanyName,
  ContactEmailAddress,
} from '../../utils/Constants';
// Images
import MainLogo from '../../assets/images/logos/miss-dominatrixa-logo-monotone.webp';
// Data
import { FooterLinksArray } from '../../utils/data/FooterData';
import { MainServicesArray } from '../../utils/data/CompanyData';

function FooterComponent() {
  return (
    <footer
      className='grid bg-colour3 dark:bg-colour3 text-colour5 dark:text-colour5 full_shadow_black_invert w-full overflow-hidden py-6 md:py-12 px-6 md:px-20 font-poppins'
      role='contentinfo'
      aria-labelledby='footer-title'
    >
      <div className='grid lg:grid-cols-3 mx-auto gap-6 bg-colour4 dark:bg-colour4 full_shadow_black_invert rounded-md px-2 md:px-10 py-8 w-full'>
        {/* Logo & Branding Section */}
        <section
          className='grid h-fit my-auto gap-4 py-2 w-full'
          aria-labelledby='footer-branding'
        >
          <div className='grid items-center justify-center'>
            <img
              src={MainLogo}
              alt={`${CompanyName} - Professional Services`}
              className='min-w-6 max-w-[70vw] w-full'
              loading='lazy'
            />
          </div>
          <div className='text-center'>
            <p className='text-sm'>{CompanyTagLine}</p>
          </div>
        </section>

        {/* Navigation Links */}
        <nav
          className='grid grid-cols-2 px-2 gap-2 w-full'
          aria-labelledby='footer-navigation'
        >
          {/* Quick Links */}
          <section
            className='grid grid-rows-reg w-full lg:justify-center text-center'
            aria-labelledby='quick-links'
          >
            <div className='grid h-fit'>
              <h6 id='quick-links' className='text-left w-full font-semibold'>
                Quick Links
              </h6>
              <div className='border-b-2 border-solid border-colour2 dark:border-colour2 pt-2 mb-2'></div>
            </div>
            <ul className='text-left grid w-full'>
              {FooterLinksArray.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.route}
                    aria-label={`Navigate to ${link.name} page`}
                    className=''
                    onClick={() => window.scroll(0, 0)}
                    aria-current={({ isActive }) =>
                      isActive ? 'page' : undefined
                    }
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </section>

          {/* Services List */}
          <section
            className='grid grid-rows-reg justify-center text-center'
            aria-labelledby='services-list'
          >
            <div className='grid h-fit'>
              <h6 id='services-list' className='text-left font-semibold'>
                Services
              </h6>
              <div className='border-b-2 border-solid border-colour2 dark:border-colour2 pt-2 mb-2'></div>
            </div>
            <ul className='grid h-fit text-left'>
              {MainServicesArray.map((service) => (
                <li key={service.label} className=''>
                  {service.label}
                </li>
              ))}
            </ul>
          </section>
        </nav>

        {/* Contact Information */}
        <section
          className='grid grid-rows-reg gap-2 w-full px-2'
          aria-labelledby='contact-info'
        >
          <div>
            <h6 id='contact-info' className='text-left font-semibold'>
              Contact
            </h6>
            <div className='border-b-2 border-solid border-colour2 dark:border-colour2 pt-2 mb-2'></div>
          </div>

          <section className='grid gap-1 h-fit'>
            <p className='overflow-hidden'>
              <a
                href={`mailto:${ContactEmailAddress}`}
                aria-label={`Email ${CompanyName}`}
              >
                <span className='font-semibold'>Email: </span>
                {ContactEmailAddress}
              </a>
            </p>
          </section>
        </section>
      </div>
    </footer>
  );
}

export default FooterComponent;
